(ns minorodata.components.transformations.json-flattening
  "Standalone container for the SQL generator (a.k.a. JSON-flattening) modal.
   Route-gated by `:json-flattening true` in the URL query, mounts the
   shared `view` from `sql-generator.view` and supplies the standalone
   header actions (group-select, copy, insert).

   TODO: Rename `json-flattening` ns and events to `sql-generator` for clarity."
  (:require
   ["react" :as react]
   [clojure.string :as c.string]
   [minorodata.app.handlers :refer [dispatch dispatch-sync]]
   [minorodata.components.transformations.sql-generator.view :as view]
   [re-posh.core :as re-posh]
   [ui.button]
   [ui.dialog :refer [dialog-content dialog-root]]
   [ui.fields :as fields]))


(defn close-modal []
  (dispatch [:app.events/navigate-query {:json-flattening nil
                                         :table-name      nil}])
  (js/setTimeout #(dispatch [:json-flattening/delete])
                 100))

(defn open-transform-modal [t]
  (close-modal)
  (dispatch [:sql-console-modal.events/open-transform (:transform/id t)]))


(defn modal* [{:keys [group-id]}]
  (let [code             @(re-posh/subscribe [:json-flattening/prop :json-flattening/code])
        preview-loading? @(re-posh/subscribe [:mold-http/loading? :json-flattening.api/fetch-sql])
        groups           @(re-posh/subscribe [:environments.subs/get-groups])

        [group-id set-group-id] (react/useState group-id)

        group-options (mapv (fn [{:group/keys [id name]}]
                              {:value id :text name})
                            groups)

        sql-ready? (and (not preview-loading?)
                        (not (c.string/blank? code))
                        group-id)

        insert-sql (fn []
                     (doall
                      (dispatch-sync [:sql-console.events/save-new-transform-template code])
                      (dispatch [:json-flattening.events/create-transform {:group-id   group-id
                                                                           :transform  {:command code}
                                                                           :on-success open-transform-modal}])))]

    (react/useEffect
     (fn []
       (dispatch [:groups-panel/add])
       (dispatch [:group.api/fetch-groups {:items-per-page 1000}])
       js/undefined)
     #js [])

    [dialog-root {:open  true
                  :modal false}
     [dialog-content {:size    :full
                      :modal   false
                      :x-close false
                      :class   "p-0"}
      [:f> view/view
       {:lock-table? false
        :on-close    close-modal
        :header-actions
        [:<>
         [:div {:class "flex items-center gap-2"}
          [:label {:class    "text-nowrap"
                   :html-for "json-flattening-group-select"}
           "Transform group"]
          [fields/select
           {:field       {:value  group-id
                          :action set-group-id}
            :placeholder "Select group..."
            :id          "json-flattening-group-select"
            :required    true
            :options     group-options
            :native      false
            :class       "w-72"}]]

         [view/copy-button {:text     "Copy SQL"
                            :disabled (not sql-ready?)
                            :value    code}]

         [ui.button/button
          {:on-click insert-sql
           :disabled (not sql-ready?)
           :data-cy  "json-flattening-insert-btn"}
          (if group-id
            "Insert SQL to the transform"
            "Open in SQL console")]]}]]]))


(defn modal []
  (let [route    @(re-posh/subscribe [:app-route/pull])
        group-id (get-in route [:app-route/params :group-id])
        opened?  (get-in route [:app-route/query :json-flattening])]
    (when opened? [:f> modal* {:group-id group-id}])))
